import {
  FrontendEnvironmentSchema,
  type FrontendEnvironment,
} from '@cnapse/shared/environment.schema.js';
import type { PublicBootstrapConfig } from '@cnapse/shared/bootstrap.schema.js';

function loadFallbackEnvironment(
  overrides?: Partial<{ apiBaseUrl: string; publicAppUrl: string }>,
): FrontendEnvironment {
  const raw = {
    apiBaseUrl:
      overrides?.apiBaseUrl ??
      (import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'),
    publicAppUrl:
      overrides?.publicAppUrl ??
      (import.meta.env.VITE_PUBLIC_APP_URL ||
        (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3001')),
  };

  const result = FrontendEnvironmentSchema.safeParse(raw);

  if (!result.success) {
    console.error('❌ Invalid frontend environment configuration:');
    console.error(result.error.format());
    throw new Error('Invalid environment configuration');
  }

  return result.data;
}

/** @internal Exported for unit tests — do not use in application code. */
export function parseFrontendEnvironmentForTests(
  raw: { apiBaseUrl: string; publicAppUrl: string },
): FrontendEnvironment {
  return loadFallbackEnvironment(raw);
}

let currentEnvironment: FrontendEnvironment = loadFallbackEnvironment();

export function applyBootstrapToEnvironment(bootstrap: PublicBootstrapConfig): void {
  currentEnvironment = {
    apiBaseUrl: bootstrap.apiBaseUrl,
    publicAppUrl: bootstrap.publicAppUrl,
  };
}

/**
 * URL configuration for the SPA (updated after bootstrap loads).
 */
export const environment: FrontendEnvironment = new Proxy({} as FrontendEnvironment, {
  get(_target, prop: keyof FrontendEnvironment) {
    return currentEnvironment[prop];
  },
});
